// imageProcessor.js
import React from 'react';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import { parseContentImageUrl } from 'gatsby-core-theme/src/helpers/strings';
import { parseCss } from 'gatsby-core-theme/src/helpers/css-parser';
import styles from '../components/molecules/content/content.module.scss';

const getValueFromStyle = (style, cssAttribute) => {
  const regex = new RegExp(`${cssAttribute}:\\s*([0-9]+(?:\\.[0-9]+)?)px?`, 'i');
  const match = style?.match(regex);
  return match ? Math?.floor(parseFloat(match[1])) : null;
};

const processImageNode = (node, moduleWidth = 960, loading) => {
  let stylesClass = null;
  const classes = node.attribs.class;
  if (classes?.includes('content-image--float-left')) {
    stylesClass = 'floatLeft';
  } else if (classes?.includes('content-image--float-right')) {
    stylesClass = 'floatRight';
  } else if (classes?.includes('content-image--align-center')) {
    stylesClass = 'alignCenter';
  } else if (classes?.includes('content-image--align-left')) {
    stylesClass = 'alignLeft';
  } else if (classes?.includes('content-image--align-right')) {
    stylesClass = 'alignRight';
  }

  const imgWidthData = node?.attribs?.width
    || node?.attribs?.['data-width']
    || getValueFromStyle(node?.attribs?.style, 'width')
    || '';

  const imgHeightData = node?.attribs?.height
    || node?.attribs?.['data-height']
    || getValueFromStyle(node?.attribs?.style, 'height')
    || '';

  // Parse the width and height as numbers
  const originalWidth = parseFloat(imgWidthData);
  const originalHeight = (imgHeightData === 'auto') ? 298 : parseFloat(imgHeightData);

  // If width is greater than moduleWidth, adjust the width to moduleWidth and scale height accordingly
  const imgWidth = originalWidth > moduleWidth ? moduleWidth : originalWidth || '';
  const imgHeight = originalWidth > moduleWidth
    ? Math.round((originalHeight / originalWidth) * moduleWidth)
    : originalHeight || '';

  const lazyProps = {
    src: parseContentImageUrl(node.attribs.src, imgWidth, imgHeight),
    width: imgWidth,
    height: imgHeight,
    style: node.attribs.style ? parseCss(node.attribs.style) : null,
    alt: node.attribs.alt ? node.attribs.alt : '',
    className: styles[stylesClass],
  };

  return <LazyImage {...lazyProps} loading={loading} />;
};

export default processImageNode;
